<template>
  <div>
    <div v-if="optionDelete==1">该选项已被删除</div>
    <div class="app-winners" v-if="optionDelete==0">
      <div class="back" @click="toDetail">
        <img src="../../assets/icon/ic_back.png" />查看投票详情
      </div>
      <div class="vote-box">
        <div class="vote-body">
          <div class="vote-title">{{vote.text}}</div>
          <div class="percent" v-if="show_vote==1">已获{{vote.support}}票</div>
          <div class="vote-tips">(点击图片下方的按钮帮忙投票)</div>
        </div>
        <img class="vote-img" :src="vote.image_url || defaultOptionImg" @click="wxPreViewImg(vote.image_url)" />
      </div>
      <div v-if="vote.daily==0" class="footer-btn">
        <button class="button voted" v-if="vote.is_start==0">投票未开始</button>
        <button class="button voted" v-else-if="vote.is_end">投票已结束</button>
        <button class="button" v-else-if="vote.is_vote==0" @click="comfirmVote">确认投票</button>
        <button class="button voted" v-else-if="vote.is_vote==1">您已投票</button>
        <button class="button" @click="isViewShare = true">拉票</button>
      </div>
      <div class="footer-btn" v-else>
        <button class="button voted" v-if="vote.is_start==0">投票未开始</button>
        <button class="button voted" v-else-if="vote.is_end">投票已结束</button>
        <button class="button" v-else-if="vote.today_vote==0" @click="comfirmVote">确认投票</button>
        <button class="button voted" v-else-if="vote.today_vote==1 && vote.today_end==0">您今天已投票</button>
        <button class="button voted" v-else-if="vote.today_vote==1 && vote.today_end==1">您已投票</button>
        <button class="button" @click="isViewShare = true">拉票</button>
      </div>
      <!--分享好友引导-->
      <section class="share-friend" v-if="isViewShare" @click="isViewShare = false">
        <div class="arrow">
          <img src="../../assets/icon/ic_mask_arrow.png" />
        </div>
        <div class="share-desc">点击右上角“...”</div>
        <div class="share-desc">选择“发送给朋友”或者“分享到朋友圈”</div>
        <div class="share-desc">即可完成分享</div>
      </section>

      <!-- code dialog -->
      <div class='gotoMinProgram' v-if="codeDialog">
        <div class='mask' @click='codeDialog = false'></div>
        <div class='dialog-body code-dialog-body'>
          <div class='code-header'>为保证投票真实有效，请验证</div>
          <div class='code-body'>
            <div>验证码：</div>
            <img class='code-img' :src='codeSrc' />
            <button class='refresh' @click='refreshCode'>
              <img src='../../assets/icon/ic_refresh.png' />
            </button>
          </div>
          <input type='text' class='input-verify-code' placeholder='请输入验证码' placeholder-style='color:#ccc;'
            v-model="code" />
          <div class='code-tips' v-if="codeError">请输入正确的验证码</div>
          <div class='space' v-else></div>
          <div class='code-footer'>
            <button class='btn-blue' @click='codeVote'>提交</button>
            <button class='btn-white' @click='codeDialog = false'>取消</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import router from '@/router/index'
import http from '@/utils/request';
import api from '@/utils/api'
import { getToken, formatDateTime, getDistance, setShare } from '@/utils/common'

export default {
  data() {
    return {
      submitting: false,
      vid: null,
      tableData: [],
      vote: {},
      defaultOptionImg: 'https://cdn-xcxcustom.weiyoubot.cn/material/2025-09-09/5cc406aafb877a38f002305aebd16426.jpg',
      isViewShare: false,
      codeDialog: false,
      codeSrc: '',
      codeError: false,
      code: '',
      show_vote: 0,
      optionDelete: -1
    }
  },
  components: {
    [Dialog.name]: Dialog
  },
  mounted() {
    this.vid = this.$route.query.vid;
    this.oid = this.$route.query.oid;
    this.initData();
  },
  methods: {
    initData() {
      let self = this;
      let parm = {
        vid: this.vid,
        access_token: getToken(),
        oid: this.oid
      }
      http.get(api.lotto.getCanvassDetail, parm)
        .then((res) => {
          if (res.sta == 0) {
            var d = res.data
            if (d.disable == 1) {
              self.optionDelete = 1
              // self.setData({
              //   dataNotFound: 1,
              //   optionDelete: 1
              // })
              return;
            }
            self.optionDelete = 0
            if (d.is_owner || (d.hide_result == 0 && (d.is_vote || d.is_end)) || (d.hide_result == 1 && d.is_end) || (d.hide_result == 3)) self.show_vote = 1;
            self.vote = res.data
            self.initWxShare();
          }
        })

    },
    wxPreViewImg(imgUrl) {
      window.wx.previewImage({
        current: imgUrl, // 当前显示图片的http链接
        urls: [imgUrl] // 需要预览的图片http链接列表
      });
    },
    initWxShare() {
      var self = this;
      setShare(self.vote.text, "快来参加投票吧~", 'http://m.huodongtou.cn/?vid=' + self.vid + '&oid=' + self.oid, self.vote.image_url);
    },
    toDetail() {
      router.push({
        path: '/detail',
        query: { 'vid': this.vid }
      })
    },
    comfirmVote() {
      if (this.vote.verify == 1) {
        this.codeDialog = true
        this.getCode();
        return;
      }
      if (this.vote.address) {
        this.getLocation();
        return;
      }
      this.voteComfirm()
    },
    getCode() {
      var self = this;
      let param = {
        access_token: getToken(),
        vid: this.vid,
        option_ids: [this.oid * 1]
      }
      http.post(api.lotto.getVerifyCode, param).then((res) => {
        if (res.sta == 0) {
          self.codeSrc = res.data.code || ''
          self.codeDialog = true
        }
      })
    },
    refreshCode() {
      this.getCode();
    },
    codeVote() {
      if (this.code.length != 4) {
        this.codeDialog = false
        Dialog.alert({
          title: '提示',
          message: '请输入正确的验证码'
        })
        return;
      }
      if (this.vote.address) {
        this.codeDialog = false
        this.getLocation();
        return;
      }
      this.voteComfirm()
    },
    voteComfirm(currentLongitude, currentLatitude) {
      var self = this;

      if (this.submitting) {
        return
      }
      this.submitting = true;

      let parm = {
        vid: self.vid,
        option_ids: [self.oid * 1],
        access_token: getToken(),
        form_id: '',
        notify: 0,
        code: self.code || ''
      }
      if (currentLongitude && currentLatitude) {
        parm.longitude = currentLongitude
        parm.latitude = currentLatitude
      }
      http.post(api.lotto.doVote, parm)
        .then((res) => {
          self.codeDialog = false;
          self.code = ''
          if (res.sta == 0) {
            // Toast.success('成功');
            router.push({
              path: "/success",
              query: { 'vid': self.vid }
            });
          } else {
            var code = res.errcode;
            var msg = res.msg;
            if (code == 600) {
              self.codeDialog = true
              self.getCode(self);
              return;
            } else if (code == 100) {
              msg = '您已经投过票了~';
            }
            Dialog.alert({
              title: '提示',
              message: msg
            })
          }
        })
        .finally(() => {
          this.submitting = false;
        })
    },
    getLocation() {
      var self = this;
      wx.getLocation({
        type: 'gcj02',
        success: function (res) {
          var v = self.vote;
          var requireLongitude = v.longitude;
          var requireLatitude = v.latitude;
          var currentLongitude = res.longitude;
          var currentLatitude = res.latitude;
          var distance = getDistance(requireLongitude, requireLatitude, currentLongitude, currentLatitude);
          if (distance < v.range) {
            self.voteComfirm(currentLongitude, currentLatitude);
          } else {
            Dialog.alert({
              title: '提示',
              message: '您距离可投票地点还有' + Math.round(distance) + '米，因此无法投票'
            })
          }
        },
        fail(res) {
          Dialog.alert({
            title: '提示',
            message: '获取地理位置失败fail'
          })
        }
      })
    }
  }

}

</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}
.button {
  height: rem(43);
  background-color: #00a8f3;
  color: #fff;
  font-size: rem(15);
  margin-bottom: rem(10);
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-left: rem(7);
  padding-right: rem(7);
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;
  line-height: 2.85;
  border-radius: rem(10);
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
}
.app-winners {
  background-color: #ffffff;
  height: 100%;
  min-height: rem(667);
}

.back {
  background: #cceefd;
  height: rem(40);
  line-height: rem(45);
  padding: 0 rem(15);
  font-size: rem(15);
  color: #00a8f3;
  display: flex;
  align-items: center;
}
.back img {
  display: block;
  width: rem(15);
  height: rem(15);
  margin-right: rem(5);
}
.vote-box {
  background: #fff;
  padding: rem(15);
  margin-bottom: rem(15);
}
.vote-img {
  width: 100%;
}
.vote-title {
  color: black;
  font-size: rem(17);
  overflow: hidden;
  padding-right: rem(10);
  line-height: 1.5;
  text-align: center;
  padding: rem(5) 0 rem(5);
}
.percent {
  color: #00a8f3;
  font-size: rem(14);
  text-align: center;
}
.vote-tips {
  margin-top: rem(10);
  border-top: 2px solid #eee;
  height: rem(35);
  line-height: rem(35);
  text-align: center;
  font-size: rem(13);
  color: #999;
}
progress {
  margin: rem(5) 0;
}
.voted {
  background: #aaa;
  color: #fff;
}
.footer-btn {
  display: flex;
  padding: 0 rem(15) rem(50);
  justify-content: space-between;
}
.footer-btn button {
  width: rem(165);
  margin: 0;
}

/* censor-box */
.censor-box {
  text-align: center;
}

.censor-icon {
  display: block;
  margin: rem(33) auto;
}

.censor-title {
  font-size: rem(18);
  padding-bottom: rem(20);
}

.censor-desc {
  line-height: 1.6;
  font-size: rem(14);
  color: #999;
  padding: 0 rem(40);
}

.censor-btn-success {
  background: #1aad19;
  color: #fff;
  border-radius: rem(5);
  height: rem(42);
  line-height: rem(42);
  font-size: rem(17);
  margin: rem(25) rem(15);
}

.censor-btn-back {
  position: absolute;
  bottom: rem(15);
  left: 50%;
  transform: translate(-50%, 0);
  font-size: rem(15);
  margin: 0 auto;
  padding: rem(8) rem(15);
  overflow: hidden;
}

.censor-btn-customer {
  color: #0283eb;
  border: 0;
  background: none;
  font-size: rem(13);
}

.censor-btn-customer::after {
  display: none;
}

.censor-btn-back .contact {
  position: absolute;
  left: 0;
  top: 0;
  width: rem(150);
  height: rem(50);
  opacity: 0;
}

/* code dialog */
.code-dialog-body {
  width: rem(290);
}
.code-header {
  height: rem(50);
  line-height: rem(50);
  font-size: rem(16);
  text-align: center;
  color: #fff;
  background: #00a8f8;
  border-radius: rem(5) rem(5) 0 0;
}
.code-body {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: rem(5) rem(20);
}
.code-body view {
  font-size: rem(15);
  color: #333;
}
.code-img {
  width: rem(75);
  height: rem(50);
}
.refresh {
  padding: 0 rem(5);
  background: none;
}
.refresh::after {
  display: none;
}
.refresh img {
  width: rem(20);
  height: rem(20);
}
.input-verify-code {
  display: block;
  margin: 0 auto;
  padding: 0 rem(10);
  box-sizing: border-box;
  width: rem(250);
  border: 2px solid #ddd;
  height: rem(40);
  line-height: rem(40);
  color: #333;
  font-size: rem(14);
}
.code-tips {
  font-size: rem(13);
  color: #f00;
  padding: rem(10) rem(20);
}
.code-footer {
  display: flex;
  padding: 0 rem(20) rem(20);
  justify-content: space-between;
}
.code-footer button {
  width: rem(118);
  height: rem(40);
  line-height: rem(40);
  border-radius: rem(5);
  font-size: rem(15);
}
.btn-blue {
  background: #00a8f3;
  color: #fff;
}
.btn-white {
  background: #f8f8f8;
  color: #666;
  border: 2px solid #eee;
}
.show {
  visibility: visible;
}
.hide {
  visibility: hidden;
}
.space {
  height: rem(15);
}

.share-friend {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10001;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  .arrow {
    width: 100%;
    margin-bottom: rem(100);
    text-align: end;
    img {
      margin-top: 5px;
      margin-right: rem(15);
      width: rem(58);
    }
  }
  .share-desc {
    text-align: center;
    font-size: rem(20);
    color: #22bbff;
    margin-top: rem(5);
  }
}

.gotoMinProgram {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 8433;
  top: 0;
  left: 0;
  .mask {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    z-index: 8434;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .minPanel {
    position: absolute;
    z-index: 8435;
    width: 80%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    padding: rem(20) rem(20);
    box-sizing: border-box;
    text-align: center;
    color: #333333;
    .close-btn {
      text-align: end;
      margin-top: rem(-5);
      width: 100%;

      img {
        width: rem(20);
        margin-right: rem(-8);
      }
    }
    .title {
      margin-top: rem(-10);
      font-size: rem(18);
    }
    .content {
      text-align: left;
      font-size: rem(13);
      margin-top: rem(15);
      line-height: 1.5;
    }
    .min-img-code {
      width: 100%;
      padding: rem(15) 0 rem(10);
      text-align: center;
      img {
        width: 60%;
      }
    }
    .tips {
      text-align: center;
      font-size: rem(12);
      color: #666666;
    }
  }
}

/* code dialog */
.dialog,
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
.mask {
  background: rgba(0, 0, 0, 0.4);
}
.dialog-body {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: rem(10);
  z-index: 8435;
}
.code-dialog-body {
  width: rem(290);
}

.code-header {
  height: rem(50);
  line-height: rem(50);
  font-size: rem(16);
  text-align: center;
  color: #fff;
  background: #00a8f8;
  border-radius: rem(5) rem(5) 0 0;
}

.code-body {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: rem(5) rem(20);
}

.code-body view {
  font-size: rem(15);
  color: #333;
}

.code-img {
  width: rem(75);
  height: rem(50);
}

.refresh {
  padding: 0 rem(5);
  background: none;
}

.refresh::after {
  display: none;
}

.refresh img {
  width: rem(20);
  height: rem(20);
}

.input-verify-code {
  display: block;
  margin: 0 auto;
  padding: 0 rem(10);
  box-sizing: border-box;
  width: rem(250);
  border: 2px solid #ddd;
  height: rem(40);
  line-height: rem(40);
  color: #333;
  font-size: rem(14);
}

.code-tips {
  font-size: rem(13);
  color: #f00;
  padding: rem(10) rem(20);
}

.code-footer {
  display: flex;
  padding: rem(10) rem(20);
  justify-content: space-between;
}

.code-footer button {
  width: rem(118);
  height: rem(40);
  line-height: rem(40);
  border-radius: rem(5);
  font-size: rem(15);
}

.btn-blue {
  background: #00a8f3;
  color: #fff;
}

.btn-white {
  background: #f8f8f8;
  color: #666;
  border: 2px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/pages/canvass/canvass.vue